import useUsuario from "~fetchs/useUsuario";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";
/* eslint-disable no-constant-condition */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Info from "~components/Form/components/Info";
import { CancelVisit, ConfirmTheVisit, WarningIcon } from "~misc/icons";
import ModalAction from "~components/Modal/ModalAction";
import { initialPath } from "~misc/paths";
import ModalFinalizarVisita from "../Modal/ModalFinalizarVisita";
import RotaDoDiaVloz from "./RotaDoDiaVloz";
import { useConfigureFooter } from "~hooks/useHelpers";
import useVisita from "~fetchs/Roterizacao/useVisita";
import LoaderFull from "~components/Form/components/LoaderFull";
import { useNavigate, useParams, useSearchParams  } from "react-router-dom";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import ModalResponse from "~components/Modal/ModalResponse";
import { useSaveVisita } from "~pages/RouteOptimizationV2/hooks/useRoteirizacao";
import RotaDoDiaListagemClienteCard from "./RotaDoDiaListagemClienteCard";
import { db } from "~db/db";
import { getSendedSearch } from "~pages/PriceSearchV2/utils/searchHelpers";
import useLocalStorage from "~hooks/useLocalStorage";
import useParametros from "~fetchs/useParametros";
import useOnlineStatus from "~hooks/useOnlineStatus";
import useLocal from "~fetchs/useLocal";
import Modal from "~components/Modal";
import { useToast } from "@chakra-ui/react";

const missionsStatusKey = "missionsStatus";

const RotaDoDiaListagemCliente = ({
  loading,
  error,
  cliente,
  infosTatica,
  taticaLastCreatedAtDate,
  blocosInfoTatica,
  dadosMissoes,
  loadingInfosTatica,
  missoesSplit,
}) => {
  const { missoes, total, lastCreatedAtDate } = dadosMissoes;
  const containerRef = useRef(null);
  const { parameter: clienteId } = useParams();
  const [searchParams] = useSearchParams();
  const visitaEscritorio = 
    searchParams.get("escritorio") === "sucesso" &&
    searchParams.get("mapeamento") === "sucesso" && 
    Number(searchParams.get("roteirizacao")) === Number(clienteId);
    
  const { optionLocais } = useLocal({ trilha: cliente?.trilha?.nome });
  const localEscritorioCliente = optionLocais?.find(
    (option) => Number(option.value) === 14
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState(false);
  const [, setLocalStorage] = useLocalStorage("validation", null);
  const navigate = useNavigate();
  const toast = useToast();

  const blocos = useMemo(() => {
    const acc = {};
    for (const curr of infosTatica || []) {
      if (!acc[curr.bloco]) {
        acc[curr.bloco] = blocosInfoTatica(infosTatica, curr.bloco);
      }
    }
    return acc;
  }, [infosTatica]);
  const regexp = /\/roteirizacao\/consulta\//;
  const urlTeste = regexp.test(globalThis.location.pathname);

  const [loadingSave, setLoadingSave] = useState(false);

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();
  const isOnline = useOnlineStatus();
  const { toObjectSlug } = useParametros();
  const trilhaNomeNormalizada = (cliente?.trilha?.nome || "").toUpperCase();

  const missoesPorTrilha = useMemo(() => {
    const valor = toObjectSlug?.["missoes-por-trilha"]?.valor ?? "";

    if (typeof valor !== "string") return [];

    return valor
      .split(",")
      .map((item) => item.trim().toUpperCase())
      .filter(Boolean);
  }, [toObjectSlug]);

  const shouldShowMissoes = useMemo(() => {
    if (missoesPorTrilha.length > 0) {
      return missoesPorTrilha.includes(trilhaNomeNormalizada);
    }

    return !["INFRA", "IMO"].includes(trilhaNomeNormalizada);
  }, [missoesPorTrilha, trilhaNomeNormalizada]);

  const salvarVisita = useSaveVisita(
    (data, isOffline) => {
      setLoadingSave(false);

      let messageSuccess;
      if (isOffline) {
        messageSuccess = "Visita salva offline! Será enviada quando houver conexão.";
      } else {
        messageSuccess = isOnline ? "Visita finalizada com sucesso!" : "Visita finalizada com sucesso no modo offline!";
      }

      setMessageStatus(messageSuccess);

      const checkin = data?.checkin || {};

      if (data?.dadosLoc?.latitude === null && checkin?.longitude === null) {
        setSubmessageStatus(
          "Não foi possível registrar sua latitude e longitude, mas não se preocupe, sua visita foi computada."
        );
      }
      openModal("success");
      db.visitaAtiva.clear();
    },
    () => {
      setLoadingSave(false);
      setMessageStatus("Ocorreu um erro ao salvar a visita!");
      openModal("warning");
    }
  );

  const isLoadingCombined = loadingSave || salvarVisita.isLoading;

  useEffect(() => {
    if (cliente?.trilha?.nome === undefined) {
      const timeout = setTimeout(() => {
        if (cliente?.trilha?.nome === undefined) {
          toast({
            title: `Cliente sem trilha!`,
            description: `Atenção esse cliente possui não possui uma trilha contate o suporte.`,
            status: "error",
            duration: 10000,
            isClosable: true,
            position: "top-right",
          });
        }
      }, 6000);

      return () => clearTimeout(timeout);
    }
  }, [cliente?.trilha?.nome]);

  const { cancelarVisita, finalizarVisita, linkOnSuccess, marcaMissoes } = useVisita({
    idClient: Number.parseInt(clienteId),
    salvarVisita: (body) => salvarVisita.handleSave(body, { escritorio: visitaEscritorio }),
    setLoading: setLoadingSave,
    onSuccess: () => {},
  });

  const abrirFinalizacao = async (open) => {
    if (!open || !visitaEscritorio) {
      setModalOpen(open);
      return;
    }
    setLoadingSave(true);
    try {
      if (!localEscritorioCliente) {
        throw new Error("O local de escritório do cliente não está disponível na lista de locais desta visita.");
      }
      await finalizarVisita({ localId: localEscritorioCliente.value }, cliente, "Escritório do cliente");
    } catch (error) {
      setLoadingSave(false);
      toast({ title: "Não foi possível finalizar a visita", description: error.message, status: "error", isClosable: true });
      console.error("Erro ao finalizar visita de escritório:", error);
    }
  };

  const [marcados, setMarcados] = useState({});
  const [naoMarcados, setNaoMarcados] = useState({});
  const [pontosMarcados, setPontosMarcados] = useState(0);
  const [pontosNaoMarcados, setPontosNaoMarcados] = useState(0);

  const pontosTotais = useMemo(() => {
    const totalPontos = (missoes || [])
      .flatMap((item) => (item.missoes || []).map((missao) => missao.pontos || 1))
      .reduce((acc, cur) => acc + cur, 0);
    return totalPontos;
  }, [missoes]);

  const [aderenciaPorcentagem, corAderencia] = useMemo(() => {
    const porcentagem = (pontosMarcados / (pontosTotais || 1)) * 100;
    let cor;

    if (porcentagem >= 80) cor = "bg-lime-500";
    else if (porcentagem >= 50) cor = "bg-yellow-400";
    else cor = "bg-red-500";

    return [porcentagem, cor];
  }, [pontosMarcados, pontosTotais]);

  useEffect(() => {
    const newMarcados = Object.values(marcados).flat();
    const totalPontosMarcados = newMarcados.reduce((acc, item) => acc + (item.pontos || 1), 0);

    setPontosMarcados(totalPontosMarcados);
    marcaMissoes(newMarcados);
  }, [marcados]);

  useEffect(() => {
    const newMarcados = Object.values(naoMarcados).flat();
    const totalPontosNaoMarcados = newMarcados.reduce((acc, item) => acc + (item.pontos || 1), 0);
    setPontosNaoMarcados(totalPontosNaoMarcados);
  }, [naoMarcados]);

  const [showModal, setShowModal] = useState(false);
  const alreadyApplied = useRef(false);

const indices = Array.isArray(missoesSplit)
  ? missoes
      .map((missao, indexMissao) => {
        const missaoSplit = missoesSplit.find(ms => ms.tipo === missao.tipo);
        if (
          missaoSplit &&
          Array.isArray(missao.missoes) &&
          missao.missoes.some(m => m.direcionamento === missaoSplit.direcionamento)
        ) {
          return indexMissao;
        }
        return null;
      })
      .filter(i => i !== null)
  : [];

  useEffect(() => {
    if (alreadyApplied.current || indices.length === 0) return;
    if (indices.length > 0) {
      const divsCheckbox = document.querySelectorAll(".missoes-container .listClient");
      for (const [index, div] of divsCheckbox.entries()) {
        if (indices.includes(index)) {
          const checkboxes = div.querySelectorAll('input[type="checkbox"]');
          for (const checkbox of checkboxes) {
            checkbox.click();
          }
        }
      }
    }
    alreadyApplied.current = true;
  }, [indices]);

  useConfigureFooter(
    {
      notDeveloped: false,
      hideReturnButton: true,
      buttonsComponent: (
        <div className="w-full bg-white">
          <div className="flex justify-between w-full">
            <CancelarVisitaButton urlTeste={urlTeste} setModalAction={setAction} />
            {!urlTeste && (
              <FinalizarVisitaButton
                setLoadingSave={setLoadingSave}
                setModalOpen={abrirFinalizacao}
                finalizarVisita={finalizarVisita}
                cliente={cliente}
                visitaEscritorio={visitaEscritorio}
                setShowModal={setShowModal}
                pontosMarcados={pontosMarcados}
                pontosNaoMarcados={pontosNaoMarcados}
                pontosTotais={pontosTotais}
              />
            )}
          </div>
        </div>
      ),
    },
    [cliente, pontosMarcados, pontosTotais, pontosNaoMarcados, visitaEscritorio, isOnline, localEscritorioCliente]
  );

  if (loading) {
    return (
      <div className="containerForm container bg-white p-7 rounded-lg mt-[28px] relative">
        <p>Carregando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="containerForm container bg-white p-7 rounded-lg mt-[28px] relative">
        <p>Ocorreu um erro: {error.message}</p>
      </div>
    );
  }

  const SalvarDados = async () => {
    const completedIds = Object.values(marcados)
      .flat()
      .map((m) => m.id);

    const allIds = missoes.flatMap((item) => item.missoes || []).map((m) => m.id);

    const notCompletedIds = allIds.filter((id) => !completedIds.includes(id));

    localStorage.setItem(
      missionsStatusKey,
      JSON.stringify({
        completed: completedIds,
        notCompleted: notCompletedIds,
        timestamp: Date.now(),
      })
    );
    globalThis.dispatchEvent(new Event("storage"));

    if (["TAC", "IND"].includes(cliente?.trilha?.nome)) {
      const search = await getSendedSearch({ clienteId: cliente?.id, date: new Date() });
      if (search?.dados && Object.keys(search.dados).length > 0) {
        finalizarVisita(search.dados, cliente, `Sem confirmação (Salvar Dados)`);
        setLoadingSave(true);
        setLocalStorage(null);
      } else {
        await abrirFinalizacao(true);
        setLocalStorage(null);
      }
    } else {
      await abrirFinalizacao(true);
      setLocalStorage(null);
    }
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <Modal
          title={
            <div className="text-2xl mb-8 flex justify-center items-center gap-2 flex-col w-full">
              <WarningIcon fill="red" width={45} height={45} />
              <p>Você não finalizou todas as missões desse cliente, deseja continuar e encerrar a visita?</p>
            </div>
          }
          sub={
            <div className="text-center w-full flex justify-center items-center mb-3">
              <p className="w-2/3">Missões não marcadas serão consideradas como sem sucesso.</p>
            </div>
          }
          className="flex justify-center items-center flex-col"
          onClose={() => setShowModal(false)}
          isOpen={showModal}
          buttonOne="Sim"
          buttonTwo="Não"
          linkOne={() => SalvarDados()}
          linkTwo={() => setShowModal(false)}
        />
      )}

      {isLoadingCombined ? (
        <div className="spinner__form xx">
          <LoaderFull />
        </div>
      ) : (
        <>
          {shouldShowMissoes && (
            <div className="containerForm container bg-white p-7 rounded-lg mt-[28px] relative">
              <div className="flex items-end justify-between">
                <div className="relative flex items-start gap-x-2 ">
                  <h2 className="pb-6 text-2xl font-bold title">Missões </h2>
                  <div className="absolute left-[100px] top-1">
                    <Info
                      bg="blue"
                      text="As missões executadas durante a visita devem ser marcadas no campo de ‘Com Sucesso’. Já as missões que não tiverem sido realizadas na visita (temas abordados com o cliente mas que não tenham sido executados ou temas que não tenham sido abordados) devem ser marcadas no campo de ‘Sem Sucesso’"
                    />
                  </div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <p>
                    Exibindo <b>{total}</b> itens
                  </p>
                </div>
              </div>
              <div ref={containerRef} className="mt-10">
                <div className="listClient listClient__header">
                  <div className="listClient__tipo tb:!w-[196px] xs:!w-[145px] !bg-lime-500">Com Sucesso</div>
                  <div className="listClient__tipo tb:!w-[196px] xs:!w-[145px] !bg-red-500">Sem Sucesso</div>
                  <div className="listClient__tipo">Tema da missão</div>
                  <div className="listClient__description">
                    <p>Missões</p>
                  </div>
                  <div className="listClient__hours-content">
                    <p className="listClient__hours">Tempo (min)</p>
                  </div>
                </div>
                <div className="missoes-container">
                  {missoes?.map((item, index) => (
                    <div key={item.id || `missao-${index}`}>
                      <RotaDoDiaListagemClienteCard
                        item={item}
                        index={index}
                        setMarcados={setMarcados}
                        NaosetMarcados={setNaoMarcados}
                        clienteId={cliente?.id}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-center gap-x-4 items-center max-w-[400px] mx-auto pt-10">
                <span className="flex p-1 bg-[#E6E6E6] h-[50px] rounded-md items-center gap-x-4">
                  <p className="font-bold px-2 text-nowrap">% de Sucesso</p>
                  <span
                    className={`flex items-center justify-center w-[80px] h-[40px] ${corAderencia} rounded-md text-white`}
                  >
                    {aderenciaPorcentagem.toFixed(0)}%
                  </span>
                </span>
                <span className="flex p-1 bg-[#E6E6E6] h-[50px] rounded-md items-center gap-x-2">
                  <p className="font-bold px-2 text-nowrap">Com Sucesso</p>
                  <span
                    className={`flex items-center justify-center w-[80px] h-[40px] ${corAderencia} rounded-md text-white`}
                  >
                    {pontosMarcados}
                  </span>
                </span>
              </div>
              {lastCreatedAtDate ? (
                <p className="flex justify-center mt-2">
                  Atualizado em: <strong className="ml-2">{lastCreatedAtDate}</strong>
                </p>
              ) : null}
            </div>
          )}
        </>
      )}
      {loadingInfosTatica ? (
        <div className="spinner__form">{/* <LoaderFull /> */}</div>
      ) : (
        !["IND", "INFRA", "IMO"].includes(cliente?.trilha?.nome) && (
          <RotaDoDiaVloz blocos={blocos} taticaLastCreatedAtDate={taticaLastCreatedAtDate} />
        )
      )}
      <div className="flex justify-between mt-8 mb-8 gap-x-4">
        <ModalFinalizarVisita
          isOpen={modalOpen && !visitaEscritorio}
          onClose={() => setModalOpen(false)}
          submit={finalizarVisita}
          trilha={cliente?.trilha?.nome}
        />
        <ModalAction
          isOpen={action}
          title={
            <div className="flex flex-col items-center text-center">
              <WarningIcon fill="red" width={30} height={30} />
              Atenção
            </div>
          }
          sub={<p className="mb-4 font-bold">As informações não foram salvas, deseja cancelar a visita?</p>}
          onClose={() => {
            setAction(false);
          }}
          buttonOne={"Sim"}
          buttonTwo={"Não"}
          linkOne={() => {
            setLocalStorage(null);
            cancelarVisita();
          }}
          linkTwo={() => {
            setAction(false);
          }}
        />

        <ModalResponse
          isOpen={isModalOpen}
          closeModal={(e) => {
            if (modalStatus == "success") navigate(`${initialPath}/roteirizacao/mapa`);
            closeModal();
          }}
          status={modalStatus}
          message={messageStatus}
          submessage={submessageStatus}
          link={linkOnSuccess}
        />
      </div>
    </>
  );
};

const FinalizarVisitaButton = ({
  cliente,
  visitaEscritorio = false,
  finalizarVisita,
  setLoadingSave,
  setModalOpen,
  setShowModal,
  pontosMarcados,
  pontosTotais,
  pontosNaoMarcados,
}) => {
  const { getBySlug, parametros } = useParametros();
  const { usuario } = useUsuario();
  const [unicParametros, setUnicParametros] = useState(null);
  const [searchParams] = useSearchParams();
  const toast = useToast();

  const acessoJornadaFunil = ["IMO", "INFRA"].includes(cliente?.trilha?.nome) && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');
  const mapeamentoSucesso = searchParams.get("mapeamento") === "sucesso";
  const roteirizacaoId = searchParams.get("roteirizacao");
  const { checkin } = useCheckIn();
  const acompanhamentoVisitado = Boolean(
    checkin?.funilAcompanhamentoVisitado &&
    Number(checkin.clienteId) === Number(cliente?.id)
  );
  const redirectRoteirizacaoValido = acompanhamentoVisitado || (mapeamentoSucesso && Number(roteirizacaoId) === Number(cliente?.id));

  useEffect(() => {
    getBySlug("pesquisa-obrigatoria-para-finalizar-visita").then((parametro) => {
      setUnicParametros(parametro.valor !== "nao");
    });
  }, [parametros]);

  const [validation, setLocalStorage] = useLocalStorage("validation", null);

  const validarPesquisa = () => {
    const storagePesquisas = JSON.parse(localStorage.getItem("cliente-pesquisas-mm") || "{}");
    const hoje = new Date().toISOString().split("T")[0];
    const chavePesquisa = Object.keys(storagePesquisas).find((key) => key.startsWith(`${cliente?.id} - ${hoje}`));
    const dadosDaPesquisa = chavePesquisa ? storagePesquisas[chavePesquisa]?.dados : null;
    const dadosValidos = dadosDaPesquisa != null;

    return dadosValidos && Number(cliente?.id) === Number(validation);
  };

  const isDisabled = useMemo(() => {
    if (unicParametros === null || cliente?.trilha?.nome == null) {
      return true;
    }

    if (acessoJornadaFunil) {
      return !redirectRoteirizacaoValido;
    }

    if (!["TAC", "IND"].includes(cliente.trilha.nome)) {
      return false;
    }

    return !validarPesquisa();
  }, [unicParametros, cliente?.id, cliente?.trilha?.nome, validation, redirectRoteirizacaoValido, acessoJornadaFunil]);

  const removeLocalStorage = async (id) => {
    console.log(id);
    const storagePesquisas = JSON.parse(localStorage.getItem("cliente-pesquisas-mm") || "{}");
    for (const key in storagePesquisas) {
      if (key.startsWith(`${id}`)) {
        delete storagePesquisas[key];
      }
    }
    localStorage.setItem("cliente-pesquisas-mm", JSON.stringify(storagePesquisas));
  };
  const handleClick = async () => {
    const totalMarcado = pontosMarcados + pontosNaoMarcados;
    const pesquisaValida = validarPesquisa();

    if (acessoJornadaFunil && !redirectRoteirizacaoValido) return;

    if (visitaEscritorio) {
      await setModalOpen(true);
      return;
    }

    if (pontosTotais > 0 && pontosTotais !== totalMarcado) {
      setShowModal(true);
      return;
    }
    if (["TAC", "IND"].includes(cliente?.trilha?.nome)) {
      if (pesquisaValida) {
        const search = await getSendedSearch({
          clienteId: cliente?.id,
          date: new Date(),
        });
        if (search?.dados && Object.keys(search.dados).length > 0) {
          finalizarVisita(search.dados, cliente, pesquisaValida);
          setLoadingSave(true);
          setLocalStorage(null);
          removeLocalStorage(cliente?.id);
        } else {
          setModalOpen(true);
          setLocalStorage(null);
          removeLocalStorage(cliente?.id);
        }
      } else {
        toast({
          title: `Pesquisa obrigatória não encontrada`,
          description: `Para clientes da trilha ${cliente?.trilha?.nome}, é necessário realizar uma nova pesquisa no Mapa da Mina antes de continuar.`,
          status: "warning",
          duration: 10000,
          isClosable: true,
          position: "top-right",
        });
      }
    } else {
      setModalOpen(true);
      setLocalStorage(null);
    }
  };

  return (
    <button
      className={
        isDisabled
          ? "flex items-center gap-x-2 bg-[#9ACA3C] text-[primaria] font-bold px-4 py-4 rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          : "flex items-center gap-x-2 bg-[#9ACA3C] text-[primaria] font-bold px-4 py-4 rounded-full"
      }
      disabled={isDisabled}
      onClick={handleClick}
    >
      Finalizar Visita
      <ConfirmTheVisit />
    </button>
  );
};

FinalizarVisitaButton.propTypes = {
  visitaEscritorio: PropTypes.bool,
  cliente: PropTypes.object.isRequired,
  finalizarVisita: PropTypes.func.isRequired,
  setLoadingSave: PropTypes.func.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  pontosMarcados: PropTypes.number.isRequired,
  pontosTotais: PropTypes.number.isRequired,
  pontosNaoMarcados: PropTypes.number.isRequired,
};

const CancelarVisitaButton = ({ urlTeste, setModalAction }) => {
  return (
    <button
      className={
        urlTeste
          ? "flex items-center gap-x-2 bg-[#FF2E00] text-white font-bold px-4 py-4 rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          : "flex items-center gap-x-2 bg-[#FF2E00] text-white font-bold px-4 py-4 rounded-full"
      }
      disabled={urlTeste}
      onClick={() => setModalAction(true)}
    >
      Cancelar Visita
      <CancelVisit />
    </button>
  );
};

CancelarVisitaButton.propTypes = {
  urlTeste: PropTypes.bool,
  setModalAction: PropTypes.func,
};

RotaDoDiaListagemCliente.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  cliente: PropTypes.shape({
    id: PropTypes.number,
    trilha: PropTypes.shape({
      nome: PropTypes.string,
    }),
  }),
  infosTatica: PropTypes.array,
  taticaLastCreatedAtDate: PropTypes.string,
  blocosInfoTatica: PropTypes.array,
  dadosMissoes: PropTypes.shape({
    missoes: PropTypes.shape({
      forEach: PropTypes.func,
      flatMap: PropTypes.func,
      map: PropTypes.func,
      entries: PropTypes.func,
    }),
    total: PropTypes.number,
    lastCreatedAtDate: PropTypes.string,
  }),
  loadingInfosTatica: PropTypes.bool,
  missoesSplit: PropTypes.shape({
    find: PropTypes.func,
  }),
};

export default RotaDoDiaListagemCliente;
